import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { NPTEL } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/nptel/$id")({
  component: () => <DeptContentForm cfg={NPTEL} id={Route.useParams().id} />,
});
